export default function getAltFromProductImage(imageUrl: string) {
  const match = imageUrl.match(/[^/]+(?=\.[^./]+$)/);
  if (match) {
    return match[0];
  } else {
    console.warn("could not extract alt text from product image cdn url");
  }
}
